import {Component, Input, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    FormBuilder,
    FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR, ValidationErrors,
    Validators
} from "@angular/forms";
import {Observable, Subscription} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {
    arrayIsSet,
    cleanToSpecialCharacterAndLowerCaseString,
    isNotNullOrUndefined,
    stringIsSet
} from "../../providers/service/global-variables.service";

import {dataForm} from "../auto-complete-form/auto-complete-form.component";
import {MatDialog} from "@angular/material/dialog";
import {ElementParse} from "../../ParseClass/Element.Parse";

@Component({
    selector: 'app-form-field-select-with-filter',
    templateUrl: './form-field-select-with-filter.component.html',
    styleUrls: ['./form-field-select-with-filter.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FormFieldSelectWithFilterComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FormFieldSelectWithFilterComponent
        }
    ],
    standalone: false
})
export class FormFieldSelectWithFilterComponent implements OnInit, OnDestroy, ControlValueAccessor {
    @Input() color: 'primary' | 'accent' | 'warn' = 'primary'
    @Input() possibleValues: any[] | undefined
    @Input() idsUsed: any[] | undefined
    @Input() traductionNotSet: string | undefined;
    public form: FormGroup
    public value$: Observable<{ traduction?: string, noTraduction?: string }>
    public includeUsedElement$: Observable<boolean>
    private subscriptions = new Subscription();
    public filterName$: Observable<string | undefined>
    public filterEnvironment$: Observable<string | undefined>

    constructor(fb: FormBuilder,
                private matDialog: MatDialog) {
        this.form = fb.group({
            value: [undefined, []],
            selectValue: [undefined, []],
            filterName: [undefined, []],
            filterEnvironment: [undefined, []],
            includeUsedElement: [false, []],
        })
        this.value$ = this.form.get('value')!.valueChanges.pipe(
            startWith(undefined),
            map((objectId: string) => {
                let traduction;
                let noTraduction;
                let pValue
                if (stringIsSet(objectId) && arrayIsSet(this.possibleValues)) {
                    pValue = this.possibleValues!.find(pValue => pValue.objectId === objectId);
                }
                if (pValue == null) {
                    traduction = stringIsSet(this.traductionNotSet) ? this.traductionNotSet : 'clickToSelect';
                } else {
                    noTraduction = pValue.name
                }
                return {traduction, noTraduction}
            })
        )
        this.filterName$ = this.form.get('filterName')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('filterName')?.value)
        )
        this.filterEnvironment$ = this.form.get('filterEnvironment')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('filterEnvironment')?.value)
        )
        this.includeUsedElement$ = this.form.get('includeUsedElement')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.form.get('includeUsedElement')?.value)
        )
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const value$ = this.form.get('value')!.valueChanges.pipe(
            startWith(undefined),
            map(() => this.value)
        )
        this.subscriptions.add(
            value$.subscribe(onChange)
        );

    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    writeValue(value: ElementParse) {
        if (isNotNullOrUndefined(value)) {
            setTimeout(() => {
                this.form.get('value')?.setValue(value);
                this.form.get('selectValue')?.setValue([value]);
            }, 200)
        } else {
            this.form.reset()
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // if (!isNotNullOrUndefined(this.form.get('autoComplete')?.validator)) {
        //     this.form.get('autoComplete')?.setValidators(control.validator)
        //     this.form.get('autoComplete')?.updateValueAndValidity()
        // }
        if (this.form.valid) {
            return null
        } else {
            return this.form.errors!;
        }
    }

    addControlErrors(allErrors: any, controlName: string) {
        const errors = {...allErrors};
        const controlErrors = this.form.controls[controlName].errors;
        if (controlErrors) {
            errors[controlName] = controlErrors;
        }
        return errors;
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    get value() {
        return this.form.get('value')?.value
    }

    set value(value) {
        this.form.get('value')?.setValue(value)
    }

    openDialog(dialogComponent: TemplateRef<any>) {
        const dialogref = this.matDialog.open(dialogComponent,{autoFocus: false,
            exitAnimationDuration:0.1})
        dialogref.afterClosed().subscribe((choose) => {
            if (choose) {
                this.value = this.form.get('selectValue')?.value[0]
            }
        });
    }

    unsetValue(key: string) {
        this.form.get(key)?.reset()
    }

    getPossibleValuesPredicate(elements: ElementParse[]): dataForm[] | undefined {
        if (arrayIsSet(elements)) {
            const environments = elements.reduce((prev, current) => {
                const environment = current.environment ? current.environment! : 'NONE';
                const index = prev.findIndex(env => env.valueForm === environment)
                if (index < 0) {
                    const obj: dataForm = {valueForm: environment, html: environment};
                    prev.push(obj);
                }
                return prev;
            }, [] as dataForm[])
            if (arrayIsSet(environments) && environments.length > 1) {
                return environments
            } else {
                return undefined
            }

        } else {
            return undefined;
        }
    }


    filterFunctionPredicate(elements: ElementParse[], name: string | undefined, environment: string | undefined, includeUsedElement: boolean, idsUsed: string[] | undefined): ElementParse[] {
        const idsUsedActive = (!includeUsedElement && arrayIsSet(idsUsed))
        if (arrayIsSet(elements) && (stringIsSet(name) || environment != null || idsUsedActive)) {
            return elements.filter(el => {
                let block = true
                if (stringIsSet(name)) {
                    const nameCast = cleanToSpecialCharacterAndLowerCaseString(name);
                    const elNameCast = cleanToSpecialCharacterAndLowerCaseString(el.name);
                    block = elNameCast.includes(nameCast)
                }
                if (environment != null && block) {
                    const environmentCast = cleanToSpecialCharacterAndLowerCaseString(environment);
                    const elEnvironmentCast = cleanToSpecialCharacterAndLowerCaseString(el.environment);
                    block = elEnvironmentCast.includes(environmentCast);
                }
                if (idsUsedActive && block) {
                    block = !idsUsed?.includes(el.objectId!);
                }
                return block;
            })
        } else {
            return elements
        }
    }
}
